import { FC, useCallback } from 'react';
import { AttachmentItem } from '@/entities/conversations';
import { DialogSessionActions, useDialogSessionOptional } from '@/features/DialogSession';
import { cn } from '@/shared/lib';
import { ChatMessage, ChatMessageCloud, ChatMessageContent, ChatMessageTime, ChatMessageTitle } from '@/shared/ui/Chat';
import { EmotionIndicator } from './EmotionIndicator';
import { TranscriptPhraseText } from './TranscriptPhraseText';
import { TranscriptMessageItem } from './utils';

type Props = {
  item: TranscriptMessageItem;
};

export const TranscriptChatMessage: FC<Props> = ({ item }) => {
  const dialogSession = useDialogSessionOptional();

  // Прокрутка к фразе при клике по таймстемпу вложения
  const handleScrollToPhrase = useCallback(
    (phraseId: number) => {
      dialogSession?.scrollToTranscript(String(phraseId));
    },
    [dialogSession?.scrollToTranscript],
  );

  return (
    <ChatMessage
      side={item.isIncoming ? 'left' : 'right'}
      isLast={item.isLastInGroup}
      className="transition-all duration-200 rounded-t-3xl rounded-b-md"
    >
      <ChatMessageCloud data-message-id={item.id} className={cn('transition-all')}>
        {item.isLastInGroup && <ChatMessageTitle role={item.role}>{item.username || null}</ChatMessageTitle>}
        <ChatMessageContent>
          <div className={'flex flex-col gap-4 overflow-hidden w-full'}>
            <TranscriptPhraseText text={item.text} tags={item.anonymizationTags} />
            {item.attachments.length > 0 && (
              <div className="flex flex-col gap-1.5 w-full">
                {item.attachments.map((attachment) => (
                  <AttachmentItem
                    key={attachment.id}
                    attachment={attachment}
                    compact
                    onScrollToPhrase={dialogSession ? handleScrollToPhrase : undefined}
                  />
                ))}
              </div>
            )}
            <div className="flex items-center gap-2 w-full">
              <EmotionIndicator transcript={item.data} isConsultant={!item.isIncoming} className="flex-1" />
              <DialogSessionActions
                time={item.data.startedAt}
                actions={['play', 'stop']}
                clickAction={'play'}
                scrollByPlay={false}
                className={'grow-0 shrink-0 ml-auto no-underline'}
              >
                <ChatMessageTime>{item.time}</ChatMessageTime>
              </DialogSessionActions>
            </div>
          </div>
        </ChatMessageContent>
      </ChatMessageCloud>
    </ChatMessage>
  );
};
